import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  mapSettingsChartsAddOrUpdateChart, mapSettingsChartsRemoveCharts,
} from './mapSettingsCharts.actionCreators';
import { useMapSettingsChartsSelector } from './mapSettingsCharts.selectors';
import type {
  Chart, ChartId,
} from './mapSettingsCharts.types';

export const useMapSettingsCharts = () => {
  const dispatch = useDispatch();
  const charts = useMapSettingsChartsSelector();

  const addOrUpdateChart = useCallback((chart: Chart) => {
    dispatch(mapSettingsChartsAddOrUpdateChart(chart));
  }, [dispatch]);

  const removeCharts = useCallback((ids: ReadonlyArray<ChartId>) => {
    dispatch(mapSettingsChartsRemoveCharts(new Set(ids)));
  }, [dispatch]);

  return {
    charts,
    addOrUpdateChart,
    removeCharts,
  };
};
